<template>
  <div :class="$style.root" :dir="dir">
    <CoreButtonsArrowComponent
      :class="$style.button"
      :style="zIndexString"
      :disabled="disabled"
      @click="dir === 'prev' ? swiper.slidePrev() : swiper.slideNext()"
    />
  </div>
</template>

<script>
import { useSwiper } from 'swiper/vue'

export default {
  props: {
    dir: {
      type: String
    }
  },
  setup () {
    const swiper = useSwiper()
    return {
      swiper
    }
  },
  computed: {
    disabled () {
      const isPrev = this.swiper.activeIndex === 0 && this.dir !== 'next'
      const isNext = this.swiper.activeIndex === this.swiper.slides.length - 1 && this.dir === 'next'
      return isPrev || isNext
    },
    zIndexString () {
      return `z-index: ${this.swiper.slides.length + 1}`
    }
  }
}
</script>

<style module>
.root {
}

.root[dir='prev'] {
  left: 0;
}

.root[dir='next'] {
  right: 0;
}

.root[dir='next'] .button {
  transform: rotate(180deg);
}

.button[disabled] {
  display: none;
}
</style>
